// Copyright (c) 2017 Deere & Company

/* eslint-disable complexity, max-params */

export const buildPayload = (facets, exportToExcel, language, layout = '', listId = '') => ({
    accounts: facets.dealerAccountsFacet.selectedDealers.map(dealer => dealer.account),
    export: exportToExcel,
    language,
    layout,
    listId,
    requestTypes: facets.requestTypes ?
        facets.requestTypes.selectedTypes.map(item => item.key) : [],
    requestedDateFrom: facets.requestDateFacet.dateRange.from,
    requestedDateTo: facets.requestDateFacet.dateRange.to,
    returnStatus: facets.partReturnStatusesFacet.selectedStatuses.map(status => status.key)
});

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/part-requests/shared/services/build-payload.js